import { render, staticRenderFns } from "./AppointmentExpressOnlyPhone.vue?vue&type=template&id=3eb1f92d&"
import script from "./AppointmentExpressOnlyPhone.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentExpressOnlyPhone.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb1f92d')) {
      api.createRecord('3eb1f92d', component.options)
    } else {
      api.reload('3eb1f92d', component.options)
    }
    module.hot.accept("./AppointmentExpressOnlyPhone.vue?vue&type=template&id=3eb1f92d&", function () {
      api.rerender('3eb1f92d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentExpressOnlyPhone.vue"
export default component.exports